
/**
 * Utility functions for game logic
 */

// Check if the words match (ignoring case)
export const checkWordsMatch = (word1: string, word2: string): boolean => {
  return word1.toLowerCase().trim() === word2.toLowerCase().trim();
};
